<div class="card">
  <div class="card-header-{{ color }}">
    <h4 class="card-title">
      <i class="material-icons" (click)="goBack()">arrow_left</i>
      Warehouse Item Scan Lite
    </h4>
  </div>

  <div class="card-body">

    <!-- Vendor Selection -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="vendor-header" [class.vendor-required]="!selectedVendor" [class.vendor-error]="!selectedVendor && scanStatus === 'error'" (click)="toggleVendorButtons()">
          <mat-icon [class.error-icon]="!selectedVendor && scanStatus === 'error'">business</mat-icon>
          <span *ngIf="selectedVendor">{{ selectedVendor.supplierid }} - {{ selectedVendor.suppname }}</span>
          <span *ngIf="!selectedVendor" class="vendor-placeholder" [class.error-text]="scanStatus === 'error'">Please select a vendor</span>
          <mat-icon>{{ showVendorButtons ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
        </div>

        <mat-button-toggle-group *ngIf="showVendorButtons" [value]="selectedVendor" (change)="onVendorChange($event)" class="vendor-button-group">
          <mat-button-toggle *ngFor="let vendor of availableVendors" [value]="vendor" [class.selected]="selectedVendor && vendor.supplierid === selectedVendor.supplierid">
            {{ vendor.bankref }} - {{ vendor.supplierid }}
          </mat-button-toggle>
        </mat-button-toggle-group>

      </div>
    </div>

    <!-- Scanner Input Display -->
    <div class="scanner-input-display" [class.scanning]="isScanning" [class.error]="scanStatus === 'error'" [class.warning]="scanStatus === 'warning'" [class.processing]="scanStatus === 'processing'" [class.manager-mode]="isManagerMode">
      <div class="scanner-status">
        <mat-icon class="scanner-icon">
          {{ scanStatus === 'error' ? 'error' : 
             scanStatus === 'warning' ? 'warning' : 
             scanStatus === 'processing' ? 'hourglass_empty' : 
             isScanning ? 'scanner' : (isSearchMode ? 'search' : 'keyboard') }}
        </mat-icon>
        <span class="scanner-label">
          {{ statusMessage || (isScanning ? 'Scanning...' : (isSearchMode ? 'Ready to search' : 'Ready to scan')) }}<span class="mode-indicator" [ngClass]="sendToggle.value ? 'scan-out' : 'scan-in'" *ngIf="!isScanning && !statusMessage"> - {{ sendToggle.value ? 'Scan Out Mode' : 'Scan In Mode' }}</span>
        </span>

        <!-- Mode Toggle Buttons -->
        <div class="mode-toggle-buttons" *ngIf="!isManagerMode">
          <button mat-stroked-button color="primary" (click)="toggleSearchMode()" class="mode-toggle-btn" *ngIf="!isSearchMode" matTooltip="Switch to Search Mode">
            <mat-icon>search</mat-icon>
            <span>Search</span>
          </button>

          <button mat-stroked-button color="accent" (click)="toggleSearchMode()" class="mode-toggle-btn" *ngIf="isSearchMode" matTooltip="Switch to Scanner Mode">
            <mat-icon>scanner</mat-icon>
            <span>Scanner</span>
          </button>
        </div>
      </div>

      <!-- Last Scan Time Display -->
      <div class="last-scan-time" *ngIf="lastScanTime">
        <mat-icon>schedule</mat-icon>
        <span>Last scan: {{ getLastScanTimeDisplay() }}</span>
      </div>

      <!-- Scanner Mode Input -->
      <div class="scanner-input" *ngIf="!isSearchMode" (click)="onMobileScannerInputTap()" [class.mobile-tappable]="isMobile">
        <span class="input-label">Captured:</span>
        <span class="input-value">{{ keyBuffer || (isMobile ? 'Tap to search...' : 'Waiting for input...') }}</span>
      </div>

      <!-- Search Mode Input -->
      <div class="search-input" *ngIf="isSearchMode">
        <div class="custom-search-field">
          <div class="search-input-container">
            <input type="text" [(ngModel)]="searchInput" (keyup.enter)="performSearch()" placeholder="Enter SKU, barcode, or description" class="search-input-field" #searchInputRef>
            <button type="button" (click)="performSearch()" class="search-button">
              <mat-icon>search</mat-icon>
            </button>
          </div>
        </div>
        <!-- Mobile back to scanner button -->
        <div class="mobile-search-controls" *ngIf="isMobile">
          <button mat-raised-button color="primary" (click)="toggleSearchMode()" class="back-to-scanner-btn">
            <span>Back to Scanner</span>
          </button>
        </div>
      </div>
    </div>


    <!-- Hidden input field for keyboard prevention -->
    <input #hiddenScanInput type="text" [formControl]="hiddenScanControl" class="hidden-scan-input" (focus)="onHiddenInputFocus()" (keydown)="onHiddenInputKeyDown($event)" autocomplete="off" tabindex="-1">






    <!-- Search Results Modal -->
    <div class="search-results-bottom-modal" [class.show]="showSearchResults && (searchResults.length > 0 || scanStatus === 'warning')" [class.mobile]="isMobile" (touchstart)="onBottomSheetTouchStart($event)" (touchmove)="onBottomSheetTouchMove($event)" (touchend)="onBottomSheetTouchEnd($event)">

      <div class="search-results-sheet-backdrop" (click)="closeSearchResults()"></div>
      <div class="search-results-sheet-content">
        <div class="search-results-bottom-sheet-header">
          <div class="search-results-bottom-sheet-handle"></div>
          <h6 *ngIf="searchResults.length > 0">Search Results ({{ searchResults.length }})</h6>
          <h6 *ngIf="searchResults.length === 0 && scanStatus === 'warning'">No Results Found</h6>
          <button mat-icon-button (click)="closeSearchResults()" class="close-btn">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="search-results-bottom-sheet-body">
          <!-- Existing results list -->
          <div class="search-results-list" *ngIf="searchResults.length > 0">
            <div class="search-result-item" *ngFor="let item of searchResults" (click)="selectSearchResult(item)">
              <div class="result-info">
                <div class="result-sku">{{ item.stockid }}</div>
                <div class="result-description">{{ item.description }}</div>
              </div>
              <button mat-raised-button color="primary" class="select-btn">
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </div>

          <!-- No results found -->
          <div class="no-results-section" *ngIf="searchResults.length === 0 && scanStatus === 'warning'">
            <div class="no-results-content">
              <div class="no-results-icon">
                <mat-icon>search_off</mat-icon>
              </div>
              <h6>No items found for "{{ lastSearchTerm }}"</h6>
              <p>This barcode doesn't exist in the system.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Barcode Modal - Mobile Optimized -->
    <div class="add-barcode-modal" [class.show]="showBarcodeAddModal" [class.mobile]="isMobile" (touchstart)="onBottomSheetTouchStart($event)" (touchmove)="onBottomSheetTouchMove($event)" (touchend)="onBottomSheetTouchEnd($event)">

      <div class="add-barcode-sheet-backdrop" (click)="closeBarcodeAddModal()"></div>
      <div class="add-barcode-sheet-content" [class.fullscreen]="showBarcodeAddForm">
        <div class="add-barcode-bottom-sheet-header" *ngIf="!showBarcodeAddForm">
          <div class="add-barcode-bottom-sheet-handle"></div>
          <h6>No Results Found</h6>
          <button mat-icon-button (click)="closeBarcodeAddModal()" class="close-btn">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        
        <!-- Full screen header for barcode add form -->
        <div class="add-barcode-fullscreen-header" *ngIf="showBarcodeAddForm">
          <button mat-icon-button (click)="cancelBarcodeAdd()" class="back-btn">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <h6>Add Barcode</h6>
          <button mat-icon-button (click)="closeBarcodeAddModal()" class="close-btn">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        
        <div class="add-barcode-bottom-sheet-body" [class.fullscreen-body]="showBarcodeAddForm">
          <!-- No results found - show prompt -->
          <div class="no-results-section" *ngIf="searchResults.length === 0 && scanStatus === 'warning' && !showBarcodeAddForm">
            <div class="no-results-content">
              <div class="no-results-icon">
                <mat-icon>search_off</mat-icon>
              </div>
              <h6>No items found for "{{ lastSearchTerm }}"</h6>
              <p>This barcode doesn't exist in the system. Would you like to add it to an existing item?</p>

              <!-- Add barcode actions -->
              <div class="add-barcode-actions">
                <button mat-raised-button color="primary" (click)="disableKeyboardListener();dspBarcodeAdd()" class="add-barcode-btn">
                  <mat-icon>add</mat-icon>
                  <span>Add Barcode</span>
                </button>
                <button mat-stroked-button (click)="cancelBarcodeAdd()" class="cancel-btn">
                  <mat-icon>close</mat-icon>
                  <span>Cancel</span>
                </button>
              </div>

              <!-- Error message -->
              <div class="barcode-add-error" *ngIf="barcodeAddError">
                <mat-icon>error</mat-icon>
                <span>{{ barcodeAddError }}</span>
              </div>
            </div>
          </div>

          <!-- Barcode add form - shown when they choose to add -->
          <div class="barcode-add-form-container" *ngIf="showBarcodeAddForm">
            <app-item-barcode-add [searchedfor]="lastSearchTerm" (barcode_added)="addedBarcode($event)">
            </app-item-barcode-add>
          </div>
        </div>
      </div>
    </div>

    <!-- Vendor PO Display -->
    <div class="row mb-3" *ngIf="showVendorPoTable && vendorPoDetails.length > 0">
      <div class="col-12">
        <div class="vendor-po-display">
          <div class="po-header">
            <h6>Purchase Orders for {{ currentItem?.stockid }}</h6>
            <button mat-icon-button (click)="toggleVendorPoDisplay()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="po-table">
            <div class="po-header-row">
              <div>Order #</div>
              <div>Date</div>
              <div>Status</div>
              <div>Qty</div>
              <div>Action</div>
            </div>
            <div class="po-row" *ngFor="let po of vendorPoDetails">
              <div>{{ po.orderno }}</div>
              <div>{{ po.orddate | date:'short' }}</div>
              <div>{{ po.status || 'Active' }}</div>
              <div>{{ po.quantityord }}</div>
              <button mat-button color="primary" (click)="loadOrder(po.orderno)">View</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mode Display (Only show when in manager mode) -->
    <div class="row mb-3" *ngIf="isManagerMode">
      <div class="col-12 text-center">
        <div class="mode-display">
          <div class="bulk-mode-indicator">
            <mat-icon>format_list_numbered</mat-icon>
            <span class="mode-text">MANAGER BULK MODE</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Bulk quantity input (only visible in manager mode) -->
    <div class="row mb-3" *ngIf="isManagerMode && bulkQuantity === 0">
      <div class="col-12 text-center">
        <h5 class="mb-3">Enter quantity to record:</h5>

        <!-- Expected quantity info (only show if we have a scanned item) -->
        <div class="expected-quantity-info" *ngIf="currentItem && receiving_quantity > 0">
          <div class="quantity-summary">
            <p><strong>Expected:</strong> {{ receiving_quantity + already_scanned }} | <strong>Already Scanned:</strong> {{ already_scanned }} | <strong>Remaining:</strong> {{ receiving_quantity }}</p>
          </div>
        </div>

        <div class="quantity-input-container">
          <mat-form-field appearance="outline" class="quantity-input">
            <mat-label>Quantity to Record</mat-label>
            <input matInput type="number" [(ngModel)]="bulkQuantityInput" (keyup.enter)="setBulkQuantityFromInput()" (focus)="onQuantityInputFocus()" placeholder="Enter quantity" min="1" max="9999" class="quantity-input-field">
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="setBulkQuantityFromInput()" [disabled]="!bulkQuantityInput || bulkQuantityInput < 1" class="quantity-submit-btn">
            Set Quantity
          </button>
        </div>
        <!-- Quick quantity buttons for convenience (tire batches of 4) -->
        <div class="quick-quantity-buttons">
          <span class="quick-label">Quick select:</span>
          <button mat-button *ngFor="let qty of [4, 40, 80, 120, 160, 200, 240, 280, 320, 360, 400]" (click)="setBulkQuantityInput(qty)" class="quick-quantity-btn">
            {{ qty }}
          </button>
        </div>
      </div>
    </div>

    <!-- Bulk quantity confirmation (only visible in manager mode with quantity set) -->
    <div class="row mb-3" *ngIf="isManagerMode && bulkQuantity > 0">
      <div class="col-12">
        <div class="bulk-confirmation">
          <div class="confirmation-content">
            <mat-icon class="confirmation-icon">info</mat-icon>
            <div class="confirmation-text">
              <h5>Ready to scan</h5>
              <p>When you scan a tire, it will record <strong>{{ bulkQuantity }}</strong> quantity</p>
            </div>
            <button mat-icon-button color="warn" (click)="bulkQuantity = 0; bulkQuantityInput = 0" class="clear-quantity-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Minimal Scan Feedback (Every Tire Mode) -->
    <div class="row mb-3" *ngIf="currentItem && !isManagerMode">
      <div class="col-12">
        <div class="minimal-scan-card" [class.success]="scanStatus === 'success'">
          <div class="scan-info">
            <mat-icon class="scan-icon">{{ scanStatus === 'success' ? 'check_circle' : 'inventory_2' }}</mat-icon>
            <div class="scan-details">
              <div class="scan-sku">{{ getCurrentItemName() }}</div>
            </div>
          </div>
          <div class="bin-destination" [ngClass]="getBinDestinationClass()">
            <div class="bin-label">{{ receiving_bin || 'AUTO' }}</div>
            <div class="bin-location">{{ getBinDestinationLabel() }}</div>
            <!-- <div class="scan-count" *ngIf="scan_history">
              <span class="count-value">{{ getTotalScanned() }}</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Bulk Mode Display (Manager Mode) -->
    <div class="row mb-3" *ngIf="currentItem && isManagerMode">
      <div class="col-12">
        <div class="bulk-mode-card">
          <div class="bulk-header">
            <h5>{{ currentItem.description }}</h5>
            <button mat-icon-button (click)="clearCurrentItem()" color="warn">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <div class="bulk-info">
            <div class="info-row">
              <span class="label">SKU:</span>
              <span class="value">{{ getCurrentItemName() }}</span>
            </div>
            <div class="info-row">
              <span class="label">PO Quantity:</span>
              <span class="value po-qty">{{ expectedQuantity || currentItem.openpos || 0 }}</span>
            </div>
            <div class="info-row">
              <span class="label">Already Scanned:</span>
              <span class="value">{{ already_scanned }}</span>
            </div>
            <div class="info-row">
              <span class="label">Bin:</span>
              <span class="value">{{ receiving_bin }}</span>
            </div>
          </div>

          <!-- Quantity Input (Editable) -->
          <div class="quantity-input-section">
            <mat-form-field appearance="outline" class="bulk-qty-input">
              <mat-label>Quantity to Receive</mat-label>
              <input matInput type="number" [(ngModel)]="bulkQuantityInput" min="1" class="test-input-allowed" placeholder="Enter quantity">
            </mat-form-field>
          </div>

          <!-- Large Receive Button -->
          <button mat-raised-button color="primary" class="bulk-receive-btn" (click)="receiveBulkQuantity()" [disabled]="!bulkQuantityInput || bulkQuantityInput <= 0">
            <mat-icon>done_all</mat-icon>
            Receive {{ bulkQuantityInput || 0 }} Items
          </button>
        </div>
      </div>
    </div>



    <!-- Details Toggle Button -->
    <div class="row mb-3" *ngIf="currentItem">
      <div class="col-12 position-relative">
        <button mat-stroked-button (click)="showDetails = !showDetails" class="details-toggle-btn">
          <mat-icon>{{ showDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
          {{ showDetails ? 'Hide Details' : 'Show Details' }}
        </button>
        <button *ngIf="showResetControls" mat-icon-button color="warn" (click)="clearCurrentItem()" matTooltip="Clear current item" class="clear-item-btn mr-2">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>

    <!-- Warehouse Scaninout Details Display -->
    <div class="table mt-3 shift-20" *ngIf="itemDetailsForScaninout && showDetails">
      <ng-container *ngIf="itemDetailsForScaninout.item">
        <h4 class="text-center mt-0 mb-0">
          <b style="font-weight: bold">{{ itemDetailsForScaninout.item.description }}</b>
          <b *ngIf="itemDetailsForScaninout.item.stockid == MST_ITEM_TYPE">| {{mstdetails?.itemdescription}} - REF#{{mstdetails?.orderno}}</b>
        </h4>
        <h5 class="text-center mt-2 mb-2">( {{ getCurrentItemName() }} )</h5>
        <div class="card mt-4">
          <div class="card-header card-header-tabs card-header-{{color}}-2 p-0">
            <div class="nav-tabs-navigation">
              <div class="nav-tabs-wrapper text-nowrap">
                <ul class="nav nav-tabs col-12" data-tabs="tabs">
                  <li class="nav-item col-6 mt-0 mb-0 text-center">
                    <a mat-button class="nav-link active" href="#info" data-toggle="tab">
                      <i class="material-icons">code</i> Receive
                      <div class="ripple-container"></div>
                    </a>
                  </li>
                  <li class="nav-item col-6 mt-0 mb-0 text-center">
                    <a mat-button class="nav-link" href="#history" data-toggle="tab">
                      <i class="material-icons">cloud</i>Purch
                      <div class="ripple-container"></div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="tab-content">
              <div class="tab-pane active" id="info">
                <div class="row m-0 p-0">

                  <ng-container *ngIf="!sendToggle.value">
                    <div class="col-4 text-center">
                      EXPECTED<br>
                      <span *ngIf="purchaseOrders?.total_pending">
                        {{ purchaseOrders?.total_pending }}
                      </span>
                      <span *ngIf="!purchaseOrders?.total_pending">
                        0
                      </span>
                    </div>
                    <div class="col-4 text-center">
                      ONORDER:<br>
                      <span *ngIf="purchaseOrders?.original_inbound">
                        {{ purchaseOrders?.original_inbound }}
                      </span>
                      <span *ngIf="!purchaseOrders?.original_inbound">
                        0
                      </span>
                    </div>
                    <div class="col-4 text-center">
                      SCANNED:<br><span *ngIf="already_scanned">{{ getTotalScanned() }}</span>
                      <span *ngIf="!already_scanned">0</span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="sendToggle.value">
                    <div class="col-4 text-center">
                      EXPECTED<br>
                      <span *ngIf="vendorRgas?.total_pending">
                        {{ vendorRgas?.total_pending }}
                      </span>
                      <span *ngIf="!vendorRgas?.total_pending">
                        0
                      </span>
                    </div>
                    <div class="col-4 text-center">
                      ON RGA:<br>
                      <span *ngIf="vendorRgas?.total_pending">
                        {{ vendorRgas?.total_pending }}
                      </span>
                      <span *ngIf="!vendorRgas?.total_pending">
                        0
                      </span>
                    </div>
                    <div class="col-4 text-center">
                      SCANNED:<br><span *ngIf="already_scanned">{{ getTotalScanned() }}</span>
                      <span *ngIf="!already_scanned">0</span>
                    </div>
                  </ng-container>

                  <div class="col-12 infoView" [ngClass]="showDetails ? 'col-12 infoView' : 'noView'" (click)="showDetails = !showDetails">
                    <ul class="entry-list">
                      <li>
                        <div class="spec-label">ON HAND </div>
                        <div class="spec-value">{{ itemDetailsForScaninout.total_qoh }}<span *ngIf="already_scanned">+{{ getTotalScanned() }}</span></div>
                      </li>
                      <li>
                        <div class="spec-label">ON ORDER</div>
                        <div class="spec-value">{{ getTotalOpenPOQuantity() }}</div>
                      </li>
                      <li>
                        <div class="spec-label">COMMITTED</div>
                        <div class="spec-value">{{ itemDetailsForScaninout.reserved }}</div>
                      </li>
                      <li>
                        <div class="spec-label">AVAILABLE</div>
                        <div class="spec-value">{{ itemDetailsForScaninout.total_qoh - itemDetailsForScaninout.reserved }}</div>
                      </li>
                      <li>
                        <div class="spec-label">MIN/MAX</div>
                        <div class="spec-value">
                          <ng-container *ngIf="itemDetailsForScaninout.item">
                            {{ itemDetailsForScaninout.item.minmax[0]?.minimum }} / {{ itemDetailsForScaninout.item.minmax[0]?.maximum }}
                          </ng-container>
                        </div>
                      </li>
                      <li *ngFor="let loc of itemDetailsForScaninout.bins | keyvalue">
                        <div class="spec-label">DEFAULT LOCATION</div>
                        <div class="overflow-scroll">
                          <ng-container *ngFor="let l of loc.value">
                            <ng-container *ngIf="l.defaultbin == '1'">
                              <div>
                                <div class="spec-value">{{ l.bin }} ({{ l.quantity }})</div>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </li>
                      <li *ngFor="let loc of itemDetailsForScaninout.bins | keyvalue">
                        <div class="spec-label">LOCATION</div>
                        <div class="overflow-scroll">
                          <ng-container *ngFor="let l of loc.value">
                            <ng-container *ngIf="l.defaultbin != '1' && l.quantity > 0">
                              <div class="spec-value">{{ l.bin }} ({{ l.quantity }})</div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="row mt-3 mb-2" *ngIf="itemDetailsForScaninout">
                  <!-- Purchase Orders Section -->
                  <div class="col-12 mb-3" *ngIf="getOpenPOsArray().length > 0">
                    <h6 class="text-center mt-0 mb-2">PURCHASE ORDERS</h6>
                    <div class="po-details-list">
                      <div class="po-detail-item mb-2" *ngFor="let po of getOpenPOsArray()">
                        <div class="text-center">
                          <strong>PO #{{ po.orderno }}</strong>
                        </div>
                        <div class="text-center">
                          <span>Expected: <strong>{{ po.quantityord }}</strong></span>
                          <span class="ml-2">Received: <strong>{{ po.quantityrecd }}</strong></span>
                          <span class="ml-2">Remaining: <strong>{{ po.quantityord - po.quantityrecd }}</strong></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Barcodes Section -->
                  <div class="col-12 mb-3">
                    <h6 class="text-center mt-0 mb-2">BARCODES</h6>
                    <div class="text-center spec-value">{{ itemDetailsForScaninout.item.barcode || 'N/A' }}</div>
                  </div>

                  <!-- Reserved Orders Section -->
                  <div class="col-12 mb-2" *ngIf="itemDetailsForScaninout.reserved_orders && itemDetailsForScaninout.reserved_orders.length > 0">
                    <h6 class="text-center mt-0 mb-2">COMMITTED ORDERS</h6>
                    <div class="text-center">
                      <span class="ml-2 mr-2" *ngFor="let order of itemDetailsForScaninout.reserved_orders">
                        <a class="order-details" (click)="loadOrder(order.orderno)">
                          <b>{{ order.orderno }}</b>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="tab-pane" id="history">
                <div class="table text-center" *ngIf="historyloading">
                  <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
                <div class="col-12" *ngIf="!history && !historyloading">
                  <div class="alert alert-warning">No Purchase History</div>
                </div>
                <table class="table table-sm" *ngIf="history">
                  <thead>
                    <tr>
                      <th class="text-left w-20">SUPP</th>
                      <th class="text-left w-20">PO</th>
                      <th class="text-left w-20">DATE</th>
                      <th class="text-center w-20">QTY</th>
                      <th class="text-right w-20">COST</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let h of history">
                      <td class="text-left"> {{h.suppname}}</td>
                      <td class="text-left"> {{h.orderno}}</td>
                      <td class="text-left"> {{h.orddate}}</td>
                      <td class="text-center"> {{h.quantityord}}</td>
                      <td class="text-right"> {{h.unitprice | currency}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Scan Status 
    <div class="row mb-3" *ngIf="scanStatus !== 'idle'">
      <div class="col-12">
        <div class="scan-status" [ngClass]="'status-' + scanStatus">
          <div class="status-content">
            <mat-icon class="status-icon">
              {{ scanStatus === 'success' ? 'check_circle' : 
                 scanStatus === 'error' ? 'error' : 
                 scanStatus === 'warning' ? 'warning' : 'info' }}
            </mat-icon>
            <span class="status-message">{{ statusMessage }}</span>
          </div>
        </div>
      </div>
    </div>
    -->

    <!-- Camera Scanner (optional)
    <div class="row mb-3" *ngIf="useCameraScanner">
      <div class="col-12">
        <div class="camera-scanner">
          <barcode-scanner-livestream
            #barcodeScanner
            (valueChanges)="onBarcodeScanned($event)"
            (started)="onScannerStarted($event)">
          </barcode-scanner-livestream>
        </div>
      </div>
    </div> -->

    <!-- Scan History Modal (like search results) -->
    <div class="scan-history-modal" [class.show]="showScanHistory" [class.mobile]="isMobile" (touchstart)="onBottomSheetTouchStart($event)" (touchmove)="onBottomSheetTouchMove($event)" (touchend)="onBottomSheetTouchEnd($event)">
      
      <div class="scan-history-sheet-backdrop" (click)="toggleScanHistory()"></div>
      <div class="scan-history-sheet-content">
        <div class="scan-history-bottom-sheet-header">
          <div class="scan-history-bottom-sheet-handle"></div>
          <h6>Recent Scans ({{ scan_history?.length || 0 }})</h6>
          <button mat-icon-button (click)="toggleScanHistory()" class="close-btn" aria-label="Close scan history">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="scan-history-bottom-sheet-body">
          <!-- Scan history list -->
          <div class="scan-history-list" *ngIf="scan_history && scan_history.length > 0">
            <div class="scan-history-item" *ngFor="let scan of scan_history; let i = index" (click)="selectScanHistoryItem(scan)">
              <div class="scan-history-info">
                <div class="scan-history-sku">{{ scan.stockid }}</div>
                <div class="scan-history-description">{{ getPartName(scan) }}</div>
                <div class="scan-history-meta">
                  <span class="scan-vendor" *ngIf="scan.vendor">({{ scan.vendor }})</span>
                  <span class="scan-time">{{ scan.timestamp | date:'short' }}</span>
                </div>
              </div>
              <div class="scan-history-actions" (click)="$event.stopPropagation()">
                <div class="qty-controls">
                  <button mat-icon-button color="warn" (click)="decrementScanned(scan)" class="decrement-btn" matTooltip="Decrease" aria-label="Decrease quantity">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <div class="scan-qty-display">
                    <span class="qty-label">Qty</span>
                    <span class="qty-value">{{ scan.qty }}</span>
                  </div>
                  <button mat-icon-button color="primary" (click)="incrementScanned(scan)" class="increment-btn" matTooltip="Increase" aria-label="Increase quantity">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Empty scan history -->
          <div class="empty-scan-history" *ngIf="!scan_history || scan_history.length === 0">
            <div class="empty-content">
              <mat-icon color="primary">history</mat-icon>
              <h6>No scans yet</h6>
              <p>Start scanning items to see history.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- MST Modal -->
<div class="mst-modal" *ngIf="showMstModal">
  <div class="modal-backdrop" (click)="closeMstModal()"></div>
  <div class="modal-content">
    <div class="modal-header">
      <h4 *ngIf="mstToggle.value">Going out MSTs</h4>
      <h4 *ngIf="!mstToggle.value">Receiving MSTs ({{vendor_selected}})</h4>
      <button mat-icon-button (click)="closeMstModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <!-- Toggle for Send/Receive -->
      <div class="mst-toggle-container">
        <mat-slide-toggle [formControl]="mstToggle" (change)="loadMstData()">
          <div class="w40" *ngIf="mstToggle.value">Send</div>
          <div class="w40" *ngIf="!mstToggle.value">Rec</div>
        </mat-slide-toggle>
      </div>

      <!-- Loading State -->
      <div class="mst-loading" *ngIf="loadingMstData">
        <div class="loading-content">
          <div class="loading-spinner">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
          <h6>Loading MST Data...</h6>
          <p>Please wait while we fetch the latest MST items.</p>
        </div>
      </div>

      <!-- Sales Order MSTs (Send) -->
      <table class="table" *ngIf="!loadingMstData && mstToggle.value && mstList.length > 0">
        <thead>
          <tr>
            <th></th>
            <th>PO#</th>
            <th>DESC</th>
            <th>Note</th>
            <th>Deliver to</th>
            <th class="text-center">ORDERED</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mst of mstList" style="height: 50px;">
            <td><button mat-raised-button (click)="preloadItem(mst); setSelectedMst(mst)">select</button></td>
            <td>{{ mst.orderno }}</td>
            <td>{{ mst.itemdesc }}</td>
            <td>{{ mst.line_note }}</td>
            <td>{{ mst.deliverto }}</td>
            <td class="text-center">{{ mst.quantity }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Purchase Order MSTs (Receive) -->
      <table class="table" *ngIf="!loadingMstData && !mstToggle.value && mstList.length > 0">
        <thead>
          <tr>
            <th></th>
            <th>PO#</th>
            <th>DESC</th>
            <th>Note</th>
            <th class="text-center">ORDERED</th>
            <th>RECEIVED</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mst of mstList" style="height: 50px;">
            <td><button mat-raised-button (click)="preloadItem(mst); setSelectedMst(mst)">select</button></td>
            <td>{{ mst.orderno }}</td>
            <td>{{ mst.itemdescription }}</td>
            <td>{{ mst.line_note }}</td>
            <td class="text-center">{{ mst.quantityord }}</td>
            <td class="text-center">{{ mst.quantityrecd }}</td>
          </tr>
        </tbody>
      </table>

      <!-- No Results - shown when no MST items found -->
      <div class="mst-no-results" *ngIf="!loadingMstData && mstList.length === 0">
        <div class="no-results-content">
          <div class="no-results-icon">
            <mat-icon>inbox</mat-icon>
          </div>
          <h6>No MST Items Found</h6>
          <p>No {{ mstToggle.value ? 'outgoing' : 'incoming' }} MST items found.</p>
          <button mat-stroked-button (click)="closeMstModal()" class="close-btn">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Advanced Controls Drawer (Pull Up) -->
<div class="advanced-controls-drawer" [class.open]="showAdvancedDrawer">
  <div class="drawer-backdrop" (click)="toggleAdvancedDrawer()" *ngIf="showAdvancedDrawer"></div>
  <div class="drawer-content">
    <div class="drawer-handle" (click)="toggleAdvancedDrawer()">
      <svg viewBox="0 0 24 24" class="handle-icon" *ngIf="!showAdvancedDrawer">
        <path d="M12 2 L2 8 L12 14 L22 8 Z" stroke-width="2" fill="none" stroke="currentColor" stroke-linejoin="round" />
        <path d="M2 16 L12 22 L22 16" stroke-width="2" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 14 L12 22" stroke-width="2" stroke="currentColor" stroke-linecap="round" />
      </svg>
      <svg viewBox="0 0 24 24" class="handle-icon" *ngIf="showAdvancedDrawer">
        <line x1="4" y1="12" x2="20" y2="12" stroke-width="3" stroke="currentColor" stroke-linecap="round" />
        <line x1="12" y1="4" x2="12" y2="20" stroke-width="3" stroke="currentColor" stroke-linecap="round" />
      </svg>
      <span class="handle-label">{{ showAdvancedDrawer ? 'CLOSE' : 'OPTIONS' }}</span>
      
      <!-- Socket Status - Always visible in handle -->
      <div class="handle-socket-status" [ngClass]="getSocketStatusClass()" 
           [matTooltip]="socketConnected ? 'Socket Connected' : 'Click to reconnect'" 
           (click)="!socketConnected && reconnectSocket(); $event.stopPropagation()"
           [class.clickable]="!socketConnected">
        <mat-icon class="socket-icon">{{ getSocketStatusIcon() }}</mat-icon>
        <span class="socket-text">{{ socketStatusMessage }}</span>
      </div>
    </div>

    <div class="drawer-body" *ngIf="showAdvancedDrawer">

      <div class="advanced-controls-grid">
        <!-- Manager Mode Toggle -->
        <button class="nav-btn advanced-btn" [class.active]="isManagerMode" [class.manager-active]="isManagerMode" (click)="toggleManagerMode(); toggleAdvancedDrawer()" [attr.aria-label]="isManagerMode ? 'Exit Manager Mode' : 'Enter Manager Mode'" [attr.aria-pressed]="isManagerMode">
          <div class="nav-btn-icon">
            <svg viewBox="0 0 32 32" class="icon-svg">
              <rect x="6" y="8" width="20" height="16" rx="2" stroke-width="2.5" fill="none" stroke="currentColor" />
              <path d="M10 8 L16 4 L22 8" stroke-width="2.5" fill="none" stroke="currentColor" stroke-linejoin="round" />
              <line x1="12" y1="14" x2="20" y2="14" stroke-width="2" stroke="currentColor" />
              <line x1="12" y1="18" x2="20" y2="18" stroke-width="2" stroke="currentColor" />
            </svg>
          </div>
          <span class="nav-btn-label">{{ isManagerMode ? 'MANAGER' : 'SINGLE' }}</span>
        </button>

        <!-- Scan In/Scan Out Toggle -->
        <button class="nav-btn advanced-btn" [class.active]="true" [class.scan-in-active]="!sendToggle.value" [class.scan-out-active]="sendToggle.value" (click)="toggleReceiveSend(); toggleAdvancedDrawer()" [attr.aria-label]="sendToggle.value ? 'Switch to Scan In' : 'Switch to Scan Out'" [attr.aria-pressed]="sendToggle.value">
          <div class="nav-btn-icon">
            <svg viewBox="0 0 32 32" class="icon-svg" *ngIf="!sendToggle.value">
              <!-- Scan In: Arrow down into box -->
              <rect x="6" y="14" width="20" height="14" rx="1.5" stroke-width="2.5" fill="none" stroke="currentColor" />
              <path d="M16 4 L16 18 M11 13 L16 18 L21 13" stroke-width="2.5" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round" />
            </svg>
            <svg viewBox="0 0 32 32" class="icon-svg" *ngIf="sendToggle.value">
              <!-- Scan Out: Arrow up out of box -->
              <rect x="6" y="4" width="20" height="14" rx="1.5" stroke-width="2.5" fill="none" stroke="currentColor" />
              <path d="M16 28 L16 14 M11 19 L16 14 L21 19" stroke-width="2.5" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round" />
            </svg>
          </div>
          <span class="nav-btn-label">{{ sendToggle.value ? 'SCAN OUT' : 'SCAN IN' }}</span>
        </button>

        <!-- Clear/Reset Button (hidden; will be triggered via socket payload) -->
        <button *ngIf="showResetControls" class="nav-btn advanced-btn reset-btn" (click)="resetAllState(); toggleAdvancedDrawer()" [attr.aria-label]="'Clear All and Start Fresh'">
          <div class="nav-btn-icon">
            <svg viewBox="0 0 32 32" class="icon-svg">
              <circle cx="16" cy="16" r="12" stroke-width="2.5" fill="none" stroke="currentColor" />
              <line x1="10" y1="10" x2="22" y2="22" stroke-width="3" stroke="currentColor" stroke-linecap="round" />
              <line x1="22" y1="10" x2="10" y2="22" stroke-width="3" stroke="currentColor" stroke-linecap="round" />
            </svg>
          </div>
          <span class="nav-btn-label">CLEAR</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Bottom Navigation - Safe Frequently-Used Actions -->
<nav class="warehouse-footer-nav" *ngIf="shouldShowBottomMenu">
  <div class="nav-container">

    <!-- Undo Button (Left) -->
    <button class="nav-btn" (click)="undoLastScan()" [disabled]="!scan_history || scan_history.length === 0 || undoingLast" [attr.aria-label]="'Undo Last Scan'">
      <div class="nav-btn-icon">
        <svg viewBox="0 0 32 32" class="icon-svg">
          <path d="M8 16 C8 10 12 6 16 6 C20 6 24 10 24 16 C24 22 20 26 16 26 C13 26 10 24 8.5 21" stroke-width="2.5" fill="none" stroke="currentColor" stroke-linecap="round" />
          <path d="M3 16 L8 16 L8 11 Z" stroke-width="2.5" fill="currentColor" stroke="currentColor" stroke-linejoin="round" />
        </svg>
      </div>
      <span class="nav-btn-label">UNDO</span>
    </button>

    <!-- MST Selection (Middle) -->
    <button class="nav-btn" (click)="openMstModal()" [attr.aria-label]="'Open MST Selection'">
      <div class="nav-btn-icon">
        <svg viewBox="0 0 32 32" class="icon-svg">
          <rect x="8" y="4" width="16" height="24" rx="1.5" stroke-width="2.5" fill="none" stroke="currentColor" />
          <line x1="12" y1="10" x2="20" y2="10" stroke-width="2" stroke="currentColor" stroke-linecap="round" />
          <line x1="12" y1="15" x2="20" y2="15" stroke-width="2" stroke="currentColor" stroke-linecap="round" />
          <line x1="12" y1="20" x2="17" y2="20" stroke-width="2" stroke="currentColor" stroke-linecap="round" />
          <circle cx="13" cy="6" r="2" fill="currentColor" />
        </svg>
      </div>
      <span class="nav-btn-label">MST</span>
    </button>

    <!-- History Toggle (Right) -->
    <button class="nav-btn" [class.active]="showScanHistory" (click)="toggleScanHistory()" [attr.aria-label]="showScanHistory ? 'Hide Scan History' : 'Show Scan History'" [attr.aria-pressed]="showScanHistory">
      <div class="nav-btn-icon">
        <svg viewBox="0 0 32 32" class="icon-svg">
          <rect x="6" y="6" width="20" height="20" rx="2" stroke-width="2.5" fill="none" stroke="currentColor" />
          <line x1="10" y1="12" x2="22" y2="12" stroke-width="2" stroke="currentColor" stroke-linecap="round" />
          <line x1="10" y1="16" x2="22" y2="16" stroke-width="2" stroke="currentColor" stroke-linecap="round" />
          <line x1="10" y1="20" x2="18" y2="20" stroke-width="2" stroke="currentColor" stroke-linecap="round" />
        </svg>
      </div>
      <span class="nav-btn-label">HISTORY</span>
    </button>

  </div>
</nav>

<!-- Scan Detail Modal -->
<div class="scan-detail-modal" *ngIf="showScanDetailModal">
  <div class="modal-backdrop" (click)="closeScanDetail()"></div>
  <div class="modal-content">
    <div class="modal-header">
      <h4>Scan Details</h4>
      <button mat-icon-button (click)="closeScanDetail()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body" *ngIf="selectedScanDetail">
      <div class="detail-section">
        <h5>Item Information</h5>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">SKU:</span>
            <span class="detail-value">{{ selectedScanDetail.stockid }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Description:</span>
            <span class="detail-value">{{ selectedScanDetail.description || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Vendor:</span>
            <span class="detail-value">{{ selectedScanDetail.vendor || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">PO Number:</span>
            <span class="detail-value">{{ selectedScanDetail.ponumber || 'N/A' }}</span>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h5>Scan Information</h5>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">Quantity Scanned:</span>
            <span class="detail-value">{{ selectedScanDetail.qty }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Quantity on PO:</span>
            <span class="detail-value">{{ selectedScanDetail.qop || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Bin Location:</span>
            <span class="detail-value">{{ selectedScanDetail.bin || 'AUTO' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Scan Type:</span>
            <span class="detail-value">{{ selectedScanDetail.in_out == 0 ? 'Inbound' : 'Outbound' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Timestamp:</span>
            <span class="detail-value">{{ selectedScanDetail.timestamp | date:'medium' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Status:</span>
            <span class="detail-value" [ngClass]="getScanStatusClass(selectedScanDetail)">
              {{ getScanStatusText(selectedScanDetail) }}
            </span>
          </div>
        </div>
      </div>

      <div class="detail-section" *ngIf="selectedScanDetail.notes">
        <h5>Notes</h5>
        <div class="notes-content">
          {{ selectedScanDetail.notes }}
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button mat-raised-button color="primary" (click)="closeScanDetail()">Close</button>
    </div>
  </div>
</div>